import React from 'react';

import { withPrefix } from 'gatsby';

import { getWithoutPathPrefix } from '../../../utils';

export const CustomImage: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = ({ src, alt, ...props }) => {
  const prefixed = src?.startsWith('/')
    ? // we don't know if another plugin added a path prefix so we will remove it just to be sure
      withPrefix(getWithoutPathPrefix(src))
    : src;

  return <img {...props} src={prefixed} alt={alt} />;
};
